module.exports = __webpack_public_path__ + "img/vertical-dots.ec7788a5.svg";